"use strict";

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.Status = void 0;
var _react = _interopRequireDefault(require("react"));
var _reactI18next = require("react-i18next");
var _styledComponents = _interopRequireDefault(require("styled-components"));
var _ui = require("../ui");
var _ticker = require("../ticker");
var _reactResponsive = require("react-responsive");
var _utils = require("../../utils");
var _templateObject;
function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
function _taggedTemplateLiteral(strings, raw) { if (!raw) { raw = strings.slice(0); } return Object.freeze(Object.defineProperties(strings, { raw: { value: Object.freeze(raw) } })); }
var Tickers = _styledComponents.default.div(_templateObject || (_templateObject = _taggedTemplateLiteral(["\n  position: relative;\n  width: ", "px;\n  & > *:nth-child(2) {\n    position: absolute;\n    top: 0;\n    left: ", "px;\n  }\n"])), function (_ref) {
  var $size = _ref.$size;
  return $size * 1.5;
}, function (_ref2) {
  var $size = _ref2.$size;
  return $size / 2;
});
var Status = function Status(_ref3) {
  var status = _ref3.status,
    ticker = _ref3.ticker,
    dotProps = _ref3.dotProps,
    target = _ref3.target,
    id = _ref3.id,
    className = _ref3.className;
  var _useTranslation = (0, _reactI18next.useTranslation)(['libTransaction', 'libTransactionsTable']),
    t = _useTranslation.t;
  var statusRef = _react.default.useRef(null);
  var isSm = (0, _reactResponsive.useMediaQuery)({
    maxWidth: _utils.breakpoints.sm
  });
  return /*#__PURE__*/_react.default.createElement(_react.default.Fragment, null, /*#__PURE__*/_react.default.createElement("div", {
    ref: statusRef,
    className: className
  }, /*#__PURE__*/_react.default.createElement(_ui.WithDot, {
    position: "bottom",
    dot: /*#__PURE__*/_react.default.createElement(_ui.Dot, _extends({}, dotProps, {
      borderColor: "secondary"
    }))
  }, target ? /*#__PURE__*/_react.default.createElement(Tickers, {
    $size: 40
  }, /*#__PURE__*/_react.default.createElement(_ticker.TickerIcon, {
    size: 40,
    ticker: ticker
  }), /*#__PURE__*/_react.default.createElement(_ticker.TickerIcon, {
    size: 40,
    ticker: target.ticker
  })) : /*#__PURE__*/_react.default.createElement(_ticker.TickerIcon, {
    size: 40,
    ticker: ticker
  }))), !isSm && /*#__PURE__*/_react.default.createElement(_ui.Tooltip, {
    placement: "bottom",
    target: statusRef
  }, t('libTransactionsTable:status'), ": ", t("libTransaction:status.".concat(status))));
};
exports.Status = Status;